
import { Card } from "@/components/ui/card";

export const SurveyHeader = () => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-semibold mb-2">Gruppträff utvärdering</h1>
      <p className="text-muted-foreground">
        Fyll i formuläret nedan för att utvärdera gruppträffen
      </p>
    </div>
  );
};
